<template>
    <div class="animated fadeIn equipmentLists ContractSOR bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 contractSorTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="sor"
                        arrows >
                    <template slot="gofixTab:sor">
                        <b-row no-gutters class="heig-frame-child">
                            <b-col md="3" class="pr-15">
                                <gofix-card title="SOR Grouping" class="mb-0 h-100 contractTree">
                                    <div class="contenAbsolute">
                                        <div class="tree-view-properties">
                                            <div class="position-relative" v-bind:class="{'run-loading':loadings.group}">
                                                <tree :data="sorGroupTree" :options="{multiple: true,miltiple:true,checkbox: true,}" ref="treeViewGroup" @node:selected="selectGroup" @node:checked="checkedGroup" @node:unchecked="unCheckedGroup"><!-- :options="{checkbox: true,}" -->
                                                    <div slot-scope="{ node }" class="node-container"> {{ node.text }} </div>
                                                </tree>
                                            </div>
                                        </div>
                                    </div>
                                </gofix-card>
                            </b-col>
                            <b-col md="9">
                                <gofix-card fullContent class="equipmentCardTable h-100 scontract-equipment-scroll">
                                    <gofix-default-table :settings="tableConfig"
                                            :table-items="tableItems"
                                            @load-items="getTableData"
                                            @row-click="openCreateItem"
                                            @adjustment-items="adjustmentItems"
                                            ref="gofixTable">
                                            <template slot="gofix_table:effective_date" slot-scope="row">
                                                {{row.item.effective_date  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                                            </template>
                                            <template slot="gofix_table:unit_price" slot-scope="row">
                                                {{ row.item.vendor_linking_sor.length > 0 ? row.item.vendor_linking_sor[0].unit_price : row.item.unit_price | formatMoney }}
                                            </template>
                                        </gofix-default-table>
                                </gofix-card>
                            </b-col>
                        </b-row>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" modal-class="modal-create" title="Price adjustment" hide-footer :centered="true" v-model="modals.price.open">
            <div v-bind:class="{'run-loading':modals.price.loading}">
                <b-form class="">
                    <b-row>
                        <!-- <b-col md="12">
                            <div class="d-flex gofix-radio-button">
                                <label class="mr-3"><input type="radio" v-model="modals.price.data.type" value="up"><span>MARK UP</span></label>
                                <label><input type="radio" v-model="modals.price.data.type" value="down"><span>MARK DOWN</span></label>
                            </div>
                        </b-col> -->
                        <b-col md="6">
                            <gofix-form-dropdown
                                    label="SOR Adjustment Mark"
                                    :options="adjustmentMark"
                                    v-model="modals.price.data.type"
                                    :filterable="false">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-number label="Percentage" v-model="modals.price.data.percentage" :integer-limit="3" suffix="%"></gofix-form-input-number>
                        </b-col>
                        <b-col md="12">
                            <p style="font-size: 14px;color: rgba(0, 0, 0, 0.6);display: contents;">
                                mark-up: can input SOR Adjustment > 100% <br/>
                                mark-down: can input SOR Adjustment < 100%
                            </p>
                        </b-col>
                    </b-row>
                </b-form>

                <b-button-group class="d-block text-right">
                    <gofix-button label="APPLY" @click="adjustmentItemsCallback" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import tabData from '@/data/_tabs';
    import LiquorTree from 'liquor-tree';
    import { filters } from '@/_filterVar.js';

    export default {
        name: 'sor',
        components: {
            [LiquorTree.name]: LiquorTree,
        },
        data () {
            let filter = JSON.parse(JSON.stringify(filters['sor_master']));
            filter.is_maintenance.value = false;
            delete filter.contract_term_id;
            return {
                contract_tab:tabData.supplier_contract,
                tableConfig:{
                    name: 'supplier-contract-sor',
                    controls:{
                        create:false,
                        delete:false,
                        allItems:true,
                        adjustment:true,
                        tableImport: false,
                        tableExport: false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "sor_code",
                    sortDirection: "asc",
                },
                tableItems: [],
                sorGroupTree: [],
                groupSelected: null,
                loadings: {
                    group: false,
                    vendorLinking: false
                },
                activeClass: false,
                adjustmentMark: [{
                      value: 'up',
                      label: 'Mark Up'
                    },
                    {
                      value: 'down',
                      label: 'Mark Down'
                    }
                ],
                modals:{
                    price:{
                        open: false,
                        loading: false,
                        data:{
                            type:"up",
                            percentage: null,
                            ids: [],
                            filter: null,
                            contract_id: this.$route.params.id,
                            type: {
                                value: 'up',
                                label: 'Mark Up'
                            },
                        },
                    }
                }
            }
        },
        created () {
            if(!this.$route.params.hasOwnProperty('id') || isNaN(this.$route.params.id)) {
                return this.$router.push(`/v2/contract-supplier`);
            }
            //Get contract data
            if((!this.contract || !this.contract.id) || this.contract.hasOwnProperty('id')) {
                this.$store.dispatch( 'ContractController/getSContract', this.$route.params.id)
                    .catch(error => { this.$router.push(`/v2/contract-supplier`) })
            }

            //Get sor group data
            this.getGroupSor();
        },
        computed: {
            ...mapGetters({
                contract: 'ContractController/SContract',
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        watch: {
            sorGroupTree: function (val) {
                this.$set(this.$refs.treeViewGroup, 'model', val);
                this.$refs.treeViewGroup.tree.setModel(val);
            },
             ClientContractID: function(val, old) {
                if(val && val.client_id !== old.client_id) {
                    return this.$router.push(`/v2/contract-supplier`)
                }
            },
        },
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                let params = Object.assign(tableRequest,{
                    supplier_contract_id: this.$route.params.id,
                });

                let checked = this.$refs.treeViewGroup.findAll({state: { checked: true } })
                let ids = checked.map(x=> x.id);
                if(ids && ids.length){
                    params.filter.sor_group_id.value = ids;
                }

                if(this.groupSelected && params.filter && params.filter.id){
                    params.filter.id.value = parseInt(this.groupSelected);
                }

                await this.$store.dispatch("v2SorController/getItems", params)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the SOR", "danger");
                        reject();
                    })
            },
            openCreateItem(item){
                this.$store.commit("v2SorController/setItem",null);
                this.$router.push({name:"s-edit-sor",params:{sor_id:item.id}});
            },
            adjustmentItems(ids, filter) {
                this.modals.price.open = true;
                this.modals.price.data.ids = ids;
                this.modals.price.data.filter = filter;
            },
            adjustmentItemsCallback(){
                let params = JSON.parse(JSON.stringify(this.modals.price.data));
                params.percentage = this.$accounting.unformat(params.percentage);
                params.type = params.type ? params.type.value : 'down'
                if(!params.percentage){
                    return this.$alertNotification("Please enter the percentage", "danger");
                }
                if(params.type == 'down' && params.percentage > 100){
                    return this.$alertNotification("Mark Down: can't input SOR Adjustment > 100%", "danger");
                }
                this.modals.price.loading = true;
                this.$store.dispatch("v2SorController/adjustmentItems",params)
                    .then( response => {
                        this.modals.price.loading = false;
                        this.modals.price.open = false;
                        this.$alertNotification(this.$notificationV2('editing', 'adjustment'));
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(err => {
                        this.modals.price.loading = false;
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    });
            },

            /*--  -------------------------*/
            //Get group
            getGroupSor(){
                let data = {
                    supplier_contract_id : this.$route.params.id
                };
                this.loadings.group = true;
                this.$store.dispatch( 'v2SorController/getTreeSORGroup',data)
                    .then( response => {
                        //tree_sor_groups sorGroupTree
                        this.sorGroupTree = response.tree_sor_groups;
                        this.loadings.group = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.loadings.group = false;
                    });
            },
            createVendorLinkingSOR(ids, filter) {
                let params = {
                    contract_id: this.$route.params.id,
                    tickID: ids,
                    untickID: [],
                    filter: filter,
                    isCMS: true
                };
                if(!filter){
                    //Filter untick
                    this.tableItems.map(item => {
                        if(!ids.includes(item.id)) {
                            params.untickID.push(item.id);
                        }
                    })
                }
                if(this.loadings.vendorLinking) return;
                this.loadings.vendorLinking = true;
                this.$store.dispatch("v2SorController/createVendorLinkingSOR",params)
                    .then( response => {
                        this.$alertNotification(this.$notificationV2('adding', 'vendor_linking_sor'));
                        this.loadings.vendorLinking = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                }).catch(err => {
                    this.loadings.vendorLinking = false;
                    if(err.response.data.error.message.error) {
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    }
                    else {
                        this.$alertNotification(err, "danger");
                    }
                });
            },
            selectGroup(node){
                //node.check();// = !node.states.checked;
                //this.groupSelected = node.id;
                //this.$refs.gofixTable.reloadTableItems();
            },
            checkedGroup(node){
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$refs.gofixTable.reloadTableItems();
                });
            },
            unCheckedGroup(node){
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$refs.gofixTable.reloadTableItems();
                });
            }
            /*-----------------------------*/
        }
    }
</script>
